import Cookies from 'js-cookie';
import { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getScreenName, getUserIsLoggedIn } from '../../../Utils/helper';
import { postGullackInfoReact } from '../../../datafetchers/productPage';
import { SnackBar } from '../PdpHeader/styled';
import { Helpful, TotalLikes } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function Wasthishelpful(props) {
  const {
    reviewId,
    isReviewed,
    productData,
    helpFulData,
    propertyTag,
    popupHelpful,
    carouselFeedback,
    selectedIndex,
    setShowCarouseFeedBackBannerOnIndex,
    userName,
    reactionType,
    showNewReviewView,
    fromReviews,
  } = props;
  const [showThumbsUp, setshowThumbsUp] = useState(false);
  const [showThumbsDown, setshowThumbsDown] = useState(false);
  const [gestureEffect, setGestureEffect] = useState('');
  const [showSelected, setSelected] = useState('');
  const [helpfulCount, setHelpfulCount] = useState(helpFulData);
  const [showToast, setShowToast] = useState(false);
  const [reviewReaction, setReviewReaction] = useState(reactionType);
  const hasGivenThumbsUp = useRef(isReviewed && reactionType == '1');
  useEffect(() => {
    const show =
      (isReviewed &&
        typeof reviewReaction != undefined &&
        reviewReaction == '1') ||
      showThumbsUp;
    const showDown =
      (isReviewed &&
        typeof reviewReaction != undefined &&
        reviewReaction == '0') ||
      showThumbsDown;
    if (show) {
      setSelected('up');
    } else if (showDown) {
      setSelected('down');
    }
  }, [showThumbsDown, showThumbsUp]);
  const isHelpfulHandler = async (currentReaction, index) => {
    setShowToast(true);
    fireEvent({
      category: currentReaction == '1' ? 'helpful_yes' : 'helpful_no',
      id: reviewId,
      product_id: productData?.id,
      screen: getScreenName(),
      user_id: JSON.parse(Cookies.get('react_user_properties'))?.user_id
        ? JSON.parse(Cookies.get('react_user_properties'))?.user_id
        : 'NA',
    });
    if (getUserIsLoggedIn()) {
      //     (!hasGivenThumbsUp || currentReaction == "0")
      // ) {
      const data = await postGullackInfoReact({
        content_id: reviewId,
        reaction: currentReaction,
        product_id: productData?.id || productData?._id,
        content_type: 1,
      });
      setHelpfulCount(data?.data?.helpful_count);
      setReviewReaction(currentReaction);
    }
    if (carouselFeedback) {
      setShowCarouseFeedBackBannerOnIndex(index, reviewId);
    } else {
      if (currentReaction == '1') {
        setshowThumbsUp(true);
        setshowThumbsDown(false);
      } else {
        if (showThumbsUp) {
          setshowThumbsUp(false);
        }
        setshowThumbsDown(true);
      }
    }
    setGestureEffect('lowOpacity');
    setTimeout(() => {
      setShowToast(false);
    }, 2000);
    setTimeout(() => {
      setGestureEffect('');
    }, 200);
  };

  return (
    <Helpful
      popupHelpful={popupHelpful}
      showNewReviewView={showNewReviewView}
      fromReviews={fromReviews}
    >
      {showToast && (
        <SnackBar className={showToast ? 'show' : ''}>
          Thank you for your feedback!
        </SnackBar>
      )}

      {/* <MotherStatus className="helpful" popupHelpful={popupHelpful}>
                {userName}
            </MotherStatus> */}
      {showNewReviewView ? (
        <div className="helpfulText">Helpful?</div>
      ) : (
        <p className="help">Found this review helpful?</p>
      )}
      <TotalLikes
        popupHelpful={popupHelpful}
        fromReviews={fromReviews}
        selected={showSelected == 'up' || showSelected == 'down'}
      >
        {!showNewReviewView ? helpfulCount > 0 : helpfulCount ? 2 : null}
        <button disabled={showThumbsUp || showSelected === 'up'}>
          <img
            className={showThumbsUp ? gestureEffect : ''}
            onClick={() => {
              isHelpfulHandler('1', selectedIndex);
            }}
            src={
              showSelected === 'up' ? images.thumbsUpRedNew : images.thumbsUpNew
            }
            alt="helpful"
          />
        </button>
        <button disabled={showThumbsDown || showSelected === 'down'}>
          <img
            className={showThumbsDown ? gestureEffect : ''}
            onClick={() => {
              isHelpfulHandler('0', selectedIndex);
            }}
            src={
              showSelected === 'down'
                ? images.thumbsDownRedNew
                : images.thumbsDownNew
            }
            alt="helpful"
          />
        </button>
      </TotalLikes>
    </Helpful>
  );
}
